export default __webpack_public_path__ + "static/media/V365_B_BD.527855b4.pdf";